module.exports = __webpack_public_path__ + "static/house-white-9564113dc143f926bbe2919e43e8d0e7.jpg";